import { PropsWithChildren } from 'react'

import { GameId } from '@common'
import cx from 'classnames'

import styles from './ItemsGrid.module.scss'

type GridProps = PropsWithChildren<{
  gameId: GameId
  className?: string
  itemCount?: number
}>

export const Grid = ({ children, gameId, className, itemCount }: GridProps) => {
  return (
    <div
      className={cx(styles.Items, styles[gameId], className, { [styles.multipleItems]: itemCount && itemCount > 2 })}
    >
      {children}
    </div>
  )
}
